module.exports = __webpack_public_path__ + "static/media/image-7.1b879f92.jpg";